import { SAVINGS_PLAN_SET_CLIENTE } from '../constants'

export function setCliente(cliente) {
    return dispatch => {
        dispatch({
            type: SAVINGS_PLAN_SET_CLIENTE,
            data: {
                client: cliente
            }
        })
    }
}

export function reducer(state, action) {
    if (action.type === SAVINGS_PLAN_SET_CLIENTE) {
        return {
            ...state,
            ...action.data,
        }
    }

    else return state
}
